import React from 'react';
import {
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core/styles';
import MAlert from '@material-ui/lab/Alert';
import { useSelector, useDispatch } from 'react-redux';
import { alertsActions } from '../../store/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
      top: 0,
      right: 0,
      marginTop: theme.spacing(1),
      margin: theme.spacing(2),
      zIndex: theme.zIndex.modal + 2,
    },
  }),
);

interface AlertProps {}

const alertsSelector = (state) => state.alerts;

const Alerts: React.FC<AlertProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const alerts = useSelector(alertsSelector);

  if (!alerts || !alerts.length) return null;

  return (
    <div className={classes.root}>
      {alerts.map((alert) => (
        <MAlert
          key={alert.id}
          severity={alert.severity}
          onClose={() =>
            dispatch(alertsActions.clear({ id: alert.id }))
          }
        >
          {alert.message}
        </MAlert>
      ))}
    </div>
  );
};

export default Alerts;
